/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (base.html.twig).
 */

// Bootstrap
import bootstrap from "bootstrap/dist/js/bootstrap.js";

// GLighbox
import GLightbox from "glightbox";

import {initSorter} from "./modules/sorter";
import {initSwiper} from "./modules/swiper";
import {initInquiryForm} from "./modules/inquiryForm";
import {initQuantityInputs} from "./modules/quantityInput";

document.addEventListener("DOMContentLoaded", () => {
    // inicializace bootstrap tooltipu
    const tooltipTriggerList = document.querySelectorAll(
        "[data-bs-toggle=\"tooltip\"]",
    );
    const _ = [...tooltipTriggerList].map(
        (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl),
    );

    // Lightbox Galerie
    GLightbox({
        touchNavigation: true,
        openEffect: "fade",
        closeEffect: "fade",
        zoomable: false,
    });

    initSwiper();
    initSorter();
    initInquiryForm();
    initQuantityInputs();
});
